export default {
    images_url: 'https://images.333travel.nl',
    filterPagesUrl: 'reizen',
    phoneNumberDisplay: '0348 - 44 19 51',
    phoneNumberShort: '0348-441951',
    phoneNumber: '0031348441951',
    flightGroupOptions: [
        {id:1, name: "1"},
        {id:2, name: "2"},
        {id:3, name: "3"},
        {id:4, name: "4"},
        {id:5, name: "5"},
        {id:6, name: "6"},
        {id:7, name: "7"},
        {id:8, name: "8"},
        {id:9, name: "9"},
        {id:10, name: "10"},
    ],

    dayParts: [
        {id: 1, label: 'Ochtend'},
        {id: 2, label: 'Voormiddag'},
        {id: 3, label: 'Namiddag'},
        {id: 4, label: 'Avond'},
    ],

    leadOpportunities: [
        {id: 1, name: 'Warme'},
        {id: 2, name: 'Gewone'},
        {id: 3, name: 'Koude'},
        {id: 4, name: 'Kansloze'},
    ],

    product_text_types: [
        { id: 1, value: 'product_information'},
        { id: 2, value: 'inclusive'},
        { id: 3, value: 'exclusive'},
        { id: 4, value: 'important_information'},
        { id: 5, value: 'highlights'},
        { id: 6, value: 'car_rental'},
        { id: 7, value: 'all_inclusive'},
    ],

    package_text_types: [
        { id: 1, value: 'product_information'},
        { id: 2, value: 'inclusive'},
        { id: 3, value: 'exclusive'},
        { id: 4, value: 'important_information'},
        { id: 5, value: 'highlights'},
        { id: 6, value: 'car_rental'},
        { id: 7, value: 'all_inclusive'},
    ],

    proposalStatuses: [
        {id: 'margin-check', name: 'Marge Controle'},
        {id: 'order-check', name: 'Product Controle'},
        {id: 'iata-check', name: 'Iata Controle'},
        {id: 'refused', name: 'Geweigerd'},
        {id: 'not-requested', name: 'Niet in aanvraag'},
        {id: 'requested', name: 'In aanvraag'},
        {id: 'to-accepted', name: 'TO Akkoord'},
        {id: 'cancelled-offers', name: 'Geannuleerde Offertes'},
    ],

    genders: [
        {id: 0, label: 'Onbekend'},
        {id: 1, label: 'Man'},
        {id: 2, label: 'Vrouw'}
    ],

    chargeUnits: [
        {id: 1, label: 'Boeking', code: 'p.b.'},
        {id: 2, label: 'Groep', code: 'p.b.'},
        {id: 3, label: 'Per nacht', code: 'p.n.'},
        {id: 4, label: 'Persoon', code: 'p.p.'},
        {id: 6, label: 'Persoon per nacht', code: 'p.p.p.n.'},
    ],

    ageGroups: [
        {id: 1, label: 'Baby'},
        {id: 2, label: 'Kind'},
        {id: 3, label: 'Volwassene'},
    ],

    checkStates: [
        {key:'open', id: 0, label: 'Open'},
        {key:'accepted', id: 1, label: 'Akkoord'},
        {key:'denied', id: 2, label: 'Afgewezen'},
    ],

    agentStatuses: {
        notRequested: {id: 0, label: 'Open', color: 'grey lighten-2'},
        requested: {id: 1, label: 'Aanvragen', color: 'warning'},
        confirmed: {id: 2, label: 'Akkoord', color: 'success'},
        changeRequired: {id: 4, label: 'Geweigerd', color: 'error'},
        denied: {id: 8, label: 'Afgewezen', color: 'error'}
    },

    actionStatuses: [
        {key: 'noActionRequired', id: 0, label: 'Geen actie vereist'},
        {key: 'actionRequired', id: 1, label: 'Actie vereist'},
        {key: 'accepted', id: 2, label: 'Goedgekeurd'},
        {key: 'denied', id: 3, label: 'Afgewezen'},
    ],

    sendMailMessages: [
        {id: 1 , label: 'Boeking aangepast mail verstuurd'},
        {id: 2 , label: 'Boeking geacepteerd mail verstuurd'},
        {id: 3 , label: 'Klant account mijn333 mail verstuurd'},
        {id: 6 , label: 'Volledig betaalde boeking mail verstuurd'},
        {id: 8 , label: 'Reisvoorstel naar klant verstuurd'},
        {id: 11 , label: 'Gepubliceerde reisbescheiden mail verstuurd'},
        {id: 13 , label: 'Welkom thuis mail verstuurd'},
        {id: 15 , label: 'Te laat betaald mail verstuurd'},
        {id: 16 , label: 'Agent product aanvraag mail verstuurd'},
        {id: 17 , label: 'Agent product geannuleerd mail verstuurd'},
        {id: 18 , label: 'Bewerkte factuur mail verstuurd'},
        {id: 19 , label: 'Offerte geaccepteerd mail verstuurd'},
        {id: 20 , label: 'Website aanvraag bevestiging'},
        {id: 21 , label: 'Zelf aangemaakte mail verstuurd'},
        {id: 23 , label: 'Nieuw mijn333 bericht update naar klant'},
        {id: 24 , label: 'Optionele producten naar klant verstuurd'},
        {id: 25 , label: 'Reiziger passport controle afgekeurd mail verstuurd'},
        {id: 26 , label: 'Agent passport gegevens beschikbaar verstuurd'},
        {id: 27 , label: 'Review mail verstuurd'},
        {id: 28 , label: 'Verzekering upsell mail verstuurd'},
        {id: 29 , label: 'Agent dossier reminder mail verstuurd'},
        {id: 30 , label: 'Agent attachment mail verstuurd'},
        {id: 31 , label: 'Platinum offerte aanvraag bevestiging mail verstuurd'},
    ],

    disabledResendSendMailMessageCids: [8, 16, 17, 18],

    mailSendStatuses: [
        {key: 'failed', id: 0, label: 'Niet verstuurd'},
        {key: 'success', id: 1, label: 'Succesvol verstuurd'},
        {key: 'pending', id: 2, label: 'Bezig...'},
    ],

    paymentMethods: [
        { id: 'Afboekingen', name: 'Afboekingen'},
        { id: 'Contant', name: 'Contant'},
        { id: 'creditcard', name: 'Creditcard'},
        { id: 'IDEAL', name: 'Ideal'},
        { id: 'MISTERCASH', name: 'Mistercash'},
        { id: 'Overboeking', name: 'Overboeking'},
        { id: 'Pin', name: 'Pin'},
        { id: 'Corona-voucher', name: 'Corona-voucher'},
    ],

    depositMethods: [
        { id: 0, 'name': 'Deutsche bank'},
        { id: 1, 'name': 'Kas'},
        { id: 2, 'name': 'Rabobank'},
        { id: 3, 'name': 'Ingenico'},
        { id: 4, 'name': 'Corona-voucher'},
    ],

    icePayStateName: {
        1: 'Onbekend (OPEN)',
        2: '(AUTHORIZED)',
        3: 'Error (ERR)',
        4: 'Succes (OK)',
        5: 'Terugbetaald (REFUND)',
        6: 'Door eindgebruiker in rekening gebracht (CBACK)',
    },

    userGroups: {
        'sales': 1,
        'sales_manager': 2,
        'product': 3,
        'cfs': 4,
        'administration': 5,
        'it': 6,
        'tickets': 7,
    },
    contextOptions: {
        single: {
            folder: [
                {
                    label: 'Openen',
                    icon: 'fa-folder-open',
                    action: 'open',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteFolder',
                }
            ],
            image: [
                {
                    label: 'Bekijken',
                    icon: 'fa-folder-open',
                    action: 'show',
                },
                {
                    label: 'Tags aanpassen',
                    icon: 'fa-tag',
                    action: 'editTags',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteItem',
                }
            ],
            vector: [
                {
                    label: 'Bekijken',
                    icon: 'fa-folder-open',
                    action: 'show',
                },
                {
                    label: 'Tags aanpassen',
                    icon: 'fa-tag',
                    action: 'editTags',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteItem',
                }
            ],
            pdf: [
                {
                    label: 'Openen',
                    icon: 'fa-folder-open',
                    action: 'open',
                },
                {
                    label: 'Tags aanpassen',
                    icon: 'fa-tag',
                    action: 'editTags',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteItem',
                }
            ],
            document: [
                {
                    label: 'Tags aanpassen',
                    icon: 'fa-tag',
                    action: 'editTags',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteItem',
                }
            ],
            video: [
                {
                    label: 'Afspelen',
                    icon: 'fa-folder-open',
                    action: 'play',
                },
                {
                    label: 'Tags aanpassen',
                    icon: 'fa-tag',
                    action: 'editTags',
                },
                {
                    label: 'Hernoemen',
                    icon: 'fa-pencil-square-o',
                    action: 'rename',
                },
                {
                    label: 'Download',
                    icon: 'fa-download',
                    action: 'download',
                },
                {
                    label: 'Verplaatsen',
                    icon: 'fa-arrows',
                    action: 'move',
                },
                {
                    label: 'Verwijderen',
                    icon: 'fa-trash-o',
                    action: 'deleteItem',
                }
            ],
        },
        multi:[
            {
                label: 'Tags aanpassen',
                icon: 'fa-tag',
                action: 'showEditSelectedTags',
            },
            {
                label: 'Download',
                icon: 'fa-download',
                action: 'downloadSelected',
            },
            {
                label: 'Verplaatsen',
                icon: 'fa-arrows',
                action: 'openMoveItems',
            },
            {
                label: 'Verwijderen',
                icon: 'fa-trash-o',
                action: 'deleteSelected',
            }
        ],
    },
    daysOfTheWeek: [
        {id: 1, name: 'Maandag'},
        {id: 2, name: 'Dinsdag'},
        {id: 3, name: 'Woensdag'},
        {id: 4, name: 'Donderdag'},
        {id: 5, name: 'Vrijdag'},
        {id: 6, name: 'Zaterdag'},
        {id: 7, name: 'Zondag'},
    ],
    productStars: [
        {id: 1, value:1,    label: '1 Ster'},
        {id: 1.5, value:1.5,  label: '1.5 Ster'},
        {id: 2, value:2,    label: '2 Sterren'},
        {id: 2.5, value:2.5,  label: '2.5 Ster'},
        {id: 3, value:3,    label: '3 Sterren'},
        {id: 3.5, value:3.5,  label: '3.5 Ster'},
        {id: 4, value:4,    label: '4 Sterren'},
        {id: 4.5, value:4.5,  label: '4.5 Ster'},
        {id: 5, value:5,    label: '5 Sterren'},
    ],
    productRelationTypes: {
        1: 'related',
        2: 'upgrade',
        3: 'downgrade',
        4: 'relatedHotel',
    },
    travelInsurance: [
        {id: 1, label: 'Geen reisverzekering'},
        {id: 2, label: 'Zelf geregeld'},
        {id: 3, label: 'Via ons geregeld'},
    ],

    cancellationInsurance: [
        {id: 1, label: 'Geen annuleringsverzekering'},
        {id: 2, label: 'Zelf geregeld'},
        {id: 3, label: 'Via ons geregeld'},
    ],
    taskState: {
        1: 'Open',
        2: 'Afgerond',
        3: 'Ter controle',
    }
}
